import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

export interface PageIntroProps {
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  className?: string;
  titleClassName?: string;
  descriptionClassName?: string;
}

export function PageIntro({
  title,
  description,
  actions,
  className,
  titleClassName,
  descriptionClassName,
}: PageIntroProps) {
  return (
    <header
      className={cn(
        "flex flex-col gap-3 border-b border-border/70 pb-4 md:flex-row md:items-center md:justify-between",
        className,
      )}
    >
      <div className="space-y-2">
        <h1 className={cn("text-2xl font-semibold tracking-tight text-foreground", titleClassName)}>
          {title}
        </h1>
        {description ? (
          <p className={cn("max-w-2xl text-sm text-muted-foreground", descriptionClassName)}>
            {description}
          </p>
        ) : null}
      </div>
      {actions ? <div className="shrink-0">{actions}</div> : null}
    </header>
  );
}
